export const countryOptions = [
  { value: 'Brazil', label: 'Brasil' },
	{ value: 'South Africa', label: 'África do Sul' },
	{ value: 'Albania', label: 'Albânia' },
	{ value: 'Germany', label: 'Alemanha' },
	{ value: 'Andorra', label: 'Andorra' },
	{ value: 'Angola', label: 'Angola' },
	{ value: 'Antigua and Barbuda', label: 'Antígua e Barbuda' },
	{ value: 'Saudi Arabia', label: 'Arábia Saudita' },
	{ value: 'Algeria', label: 'Argélia' },
	{ value: 'Argentina', label: 'Argentina' },
	{ value: 'Armenia', label: 'Armênia' },
	{ value: 'Australia', label: 'Austrália' },
	{ value: 'Austria', label: 'Áustria' },
	{ value: 'Azerbaijan', label: 'Azerbaijão' },
	{ value: 'Bahamas', label: 'Bahamas' },
	{ value: 'Bangladesh', label: 'Bangladesh' },
	{ value: 'Barbados', label: 'Barbados' },
	{ value: 'Bahrain', label: 'Barein' },
	{ value: 'Belarus', label: 'Belarus' },
	{ value: 'Belgium', label: 'Bélgica' },
	{ value: 'Belize', label: 'Belize' },
	{ value: 'Benin', label: 'Benim' },
	{ value: 'Bolivia', label: 'Bolívia' },
	{ value: 'Bosnia and Herzegovina', label: 'Bósnia e Herzegovina' },
	{ value: 'Botswana', label: 'Botsuana' },
	{ value: 'Brunei', label: 'Brunei' },
	{ value: 'Bulgaria', label: 'Bulgária' },
	{ value: 'Burkina Faso', label: 'Burkina Fasso' },
	{ value: 'Burundi', label: 'Burundi' },
	{ value: 'Bhutan', label: 'Butão' },
	{ value: 'Cape Verde', label: 'Cabo Verde' },
	{ value: 'Cameroon', label: 'Camarões' },
	{ value: 'Cambodia', label: 'Camboja' },
	{ value: 'Canada', label: 'Canadá' },
	{ value: 'Qatar', label: 'Catar' },
	{ value: 'Kazakhstan', label: 'Cazaquistão' },
	{ value: 'Chad', label: 'Chade' },
	{ value: 'Chile', label: 'Chile' },
	{ value: 'China', label: 'China' },
	{ value: 'Cyprus', label: 'Chipre' },
	{ value: 'Colombia', label: 'Colômbia' },
	{ value: 'Comoros', label: 'Comores' },
	{ value: 'Democratic Republic of the Congo', label: 'Congo' },
	{ value: 'North Korea', label: 'Coreia do Norte' },
	{ value: 'South Korea', label: 'Coreia do Sul' },
	{ value: 'Ivory Coast', label: 'Costa do Marfim' },
	{ value: 'Costa Rica', label: 'Costa Rica' },
	{ value: 'Croatia', label: 'Croácia' },
	{ value: 'Cuba', label: 'Cuba' },
	{ value: 'Denmark', label: 'Dinamarca' },
	{ value: 'Djibouti', label: 'Djibuti' },
	{ value: 'Dominica', label: 'Dominica' },
	{ value: 'Egypt', label: 'Egito' },
	{ value: 'El Salvador', label: 'El Salvador' },
	{ value: 'United Arab Emirates', label: 'Emirados Árabes Unidos' },
	{ value: 'Ecuador', label: 'Equador' },
	{ value: 'Eritrea', label: 'Eritreia' },
	{ value: 'Slovakia', label: 'Eslováquia' },
	{ value: 'Slovenia', label: 'Eslovênia' },
	{ value: 'Spain', label: 'Espanha' },
	{ value: 'Eswatini', label: 'Essuatíni' },
	{ value: 'United States', label: 'Estados Unidos' },
	{ value: 'Estonia', label: 'Estônia' },
	{ value: 'Ethiopia', label: 'Etiópia' },
	{ value: 'Finland', label: 'Finlândia' },
	{ value: 'France', label: 'França' },
	{ value: 'Gabon', label: 'Gabão' },
	{ value: 'Gambia', label: 'Gâmbia' },
	{ value: 'Ghana', label: 'Gana' },
	{ value: 'Greece', label: 'Grécia' },
	{ value: 'Guatemala', label: 'Guatemala' },
	{ value: 'Guyana', label: 'Guiana' },
	{ value: 'Haiti', label: 'Haiti' },
	{ value: 'Honduras', label: 'Honduras' },
	{ value: 'Hungary', label: 'Hungria' },
	{ value: 'India', label: 'Índia' },
	{ value: 'Indonesia', label: 'Indonésia' },
	{ value: 'Iran', label: 'Irã' },
	{ value: 'Iraq', label: 'Iraque' },
	{ value: 'Ireland', label: 'Irlanda' },
	{ value: 'Israel', label: 'Israel' },
	{ value: 'Italy', label: 'Itália' },
	{ value: 'Jamaica', label: 'Jamaica' },
	{ value: 'Japan', label: 'Japão' },
	{ value: 'Jordan', label: 'Jordânia' },
	{ value: 'Kuwait', label: 'Kuwait' },
	{ value: 'Lebanon', label: 'Líbano' },
	{ value: 'Mexico', label: 'México' },
	{ value: 'Mozambique', label: 'Moçambique' },
	{ value: 'Netherlands', label: 'Países Baixos' },
	{ value: 'New Zealand', label: 'Nova Zelândia' },
	{ value: 'Norway', label: 'Noruega' },
	{ value: 'Pakistan', label: 'Paquistão' },
	{ value: 'Portugal', label: 'Portugal' },
	{ value: 'Russia', label: 'Rússia' },
	{ value: 'Saudi Arabia', label: 'Arábia Saudita' },
	{ value: 'Sweden', label: 'Suécia' },
	{ value: 'Switzerland', label: 'Suíça' },
	{ value: 'Turkey', label: 'Turquia' },
	{ value: 'Ukraine', label: 'Ucrânia' },
	{ value: 'United Kingdom', label: 'Reino Unido' },
	{ value: 'Vatican', label: 'Vaticano' },
	{ value: 'Venezuela', label: 'Venezuela' },
	{ value: 'Vietnam', label: 'Vietnã' },
];
